// Shared input-validation primitives.

/** Pragmatic email shape check: non-space local + "@" + domain + "." + TLD. */
export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
